/**
 * Created by Kieran on 16/10/2017.
 * Code reducer for TrackingDetail views
 * reduce code duplication where logic is exactly the same across multiple files.
 */



import config from '../../config'
import ScrollManager from '../../helpers/ScrollManager'

export default {
  mounted() {
    let self = this;
    let element = document.getElementsByClassName('main-content')[0];
    element.addEventListener('scroll', self.handleScroll);
  },
  data() {
    return {
      activeReading: {},
      loading: true,
      isReadingsLoading: true,
      disableRipple: true,
      rightTop: {horizontal: 'right', vertical: 'top'},
      data: {
        data: []
      }
    }
  },
  methods: {
    sortItems() {
      let self = this;
      self.data.data.sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
    },
    sortWaistHipItems() {
      let self = this;
      self.data.sort(function (a, b) {
        return new Date(b.date_created) - new Date(a.date_created);
      });
    },
    /**
     * Mouseover event - Show edit panel
     * @param item
     */
    showItemControlsWaistHip(item) {
      let self = this;
      if (item.isControlsVisible !== true) {
        self.hideShowControlsWaistHip(item);
      }
    },
    showItemControls(item) {
      let self = this;
      if (_.has(item.userDevice, 'userDeviceId')) {
        if (item.userDevice.userDeviceId !== 0) {
        }
        else {
          self.hideShowControls(item);
        }
      }
      else {
        if (item.isControlsVisible !== true) {
          self.hideShowControls(item);
        }
      }
    },
    hideShowControlsWaistHip(item) {
      let self = this;

      self.data.map(function (reading) {
        reading.isControlsVisible = false;
      });
      item.isControlsVisible = true;
      self.$forceUpdate();
    },
    hideItemControlsWaistHip(item) {
      let self = this;
      if (!item.isEditMode) {
        item.isControlsVisible = false
        self.$forceUpdate();
      }
    },
    hideShowControls(item) {
      let self = this;

      self.data.data.map(function (reading) {
        reading.isControlsVisible = false;
      });
      item.isControlsVisible = true;
      self.$forceUpdate();
    },
    /**
     * Mouseleave event - Hide edit panel
     * @param item
     */
    hideItemControls(item) {
      let self = this;
      if (!item.isEditMode) {
        self.data.data.map(function (reading) {
          reading.isControlsVisible = false
        });
        self.$forceUpdate();
      }
    },
    /**
     * Date format for tracking list
     * @param date
     * @returns {string}
     */
    groupedDateFormat(date) {
      let self = this;
      return moment(date).locale(config.language).format('MMMM YYYY');
    },
    /**
     * Format grouped date title
     * @param date
     * @returns {string}
     */
    groupedItemDate(date) {
      let offset = new Date();
      let dateMod = moment.utc(date).locale(config.language);
      return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
    },
    groupFilter(tab) {
      let self = this;
      if (tab === 'waist-hip') {
        return _.groupBy(self.data, function (reading) {
          return moment(reading.date_created).startOf('month').format();
        })
      } else {
        return _.groupBy(self.data.data, function (reading) {
          return moment(reading.date_created).startOf('month').format();
        })
      }

    },
    closeEditMode(data) {
      let self = this;
      let currentReading = self.data.data.filter(function (reading) {
        if (_.has(reading, 'dosage_id')) {
          return reading.dosage_id === data.dosage_id;
        }
        return reading.progress_id === data.progress_id
      })[0];
      currentReading.isEditMode = false;
      currentReading.isControlsVisible = false;
      self.$forceUpdate();
    },
    closeEditModeWaistHip(data) {
      let self = this;
      let currentReading = self.data.filter(function (reading) {
        return reading.progress_id === data.progress_id
      })[0];
      currentReading.isEditMode = false;
      currentReading.isControlsVisible = false;
      self.$forceUpdate();
    },
    editReadingWaistHip(reading) {
      let self = this;
      reading.isEditMode = true;
      self.$forceUpdate();
    },
    /**
     * Click event
     * Open edit mode
     * @param reading
     */
    editReading(reading) {
      let self = this;
      self.data.data.map(function (reading) {
        return reading.isEditMode = false;
      });
      reading.isEditMode = true;
      self.$forceUpdate();
    },
    /**
     * Scroll event
     * Infinite scrolling
     */
    handleScroll: function () {
      let self = this;
      if (!self.isReadingsLoading) {
        if (ScrollManager.isElementInViewport(self.$refs['detector'])) {
          self.loadMoreData();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/TrackingDetailMixin/index.js